<ng-container *ngIf="widgetVisible && !!gridDisplayView">
    <!--Widget source id is embedded for PDF exporting algorithm (backend) to be able to localize this container inside the document.-->
    <!--If view is PDF preview, an extra class is applied to change the styles of the view correspondingly.-->
    <div [id]="widgetSourceId"
         [class]="widgetContainerClass"
         [ngClass]="{'pdf-view': output === 'PDF'}">

        <div class="widget-grid-topbar">
            <h2 *ngIf="!!widgetTitle?.length">{{ widgetTitle }}</h2>

            <!--This element is visible in web view only.-->
            <div class="exporting-buttons">
                <p-button *ngIf="exportable && output === 'web'"
                          styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                          class="exporting-button" icon="pi pi-file-pdf" title="Export to PDF"
                          [loading]="pdfExportingLoading | async" (onClick)="generatePdf()">
                </p-button>
                <p-button *ngIf="exportable && output === 'web'"
                          styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                          class="exporting-button" icon="pi pi-file-pdf" title="Export to XLS"
                          [loading]="xlsExportingLoading | async" (onClick)="generateXls()">
                </p-button>
            </div>
        </div>

        <div [class]="gridTableClass">
            <!--Web view of the widget grid table. This element is visible in web view only.-->
            <grid *ngIf="tableSettings && gridSettings && output === 'web'"
                  [tableSettings]="tableSettings"
                  [gridSettings]="gridSettings"
                  class="reporting-table"
                  (onRowSelect)="onGridRowSelect($event)"
                  (onRowUnselect)="onGridRowUnselect()">

                <ng-container *ngFor="let ct of columnTemplates">
                    <ng-template
                        *ngIf="output === 'web' && ct.column.header === 'Actions'"
                        [columnName]="ct.column.field"
                        gridColumnTemplate="displayingRow"
                        let-rowData>
                        <ng-container *ngIf="ct.column.header === 'Actions'; else customCell">
                            <div class="action-menu-cell" style="text-align: center">
                                <widget-action-menu
                                    [rowData]="rowData"
                                    [columnQueryAlias]="ct.originalColumn.queryAlias"
                                    [widgetLinks]="ct?.originalColumn?.extraSettings?.actionItems?.length !== 0
                                            ? ct?.originalColumn?.extraSettings?.actionItems
                                            : widgetLinks"
                                    [patientData]="onPatientBeforeDirect"
                                    (menuOpened)="onActionMenuOpened($event)">
                                </widget-action-menu>
                            </div>
                        </ng-container>
                        <ng-template #customCell>
                            <div *ngIf="ct.customTemplate; else normalCell"
                                 [innerHTML]="getCustomFormattedCellHtml(ct, rowData)">
                            </div>
                        </ng-template>
                        <ng-template #normalCell>
                            {{ ct.column.displayHandler(rowData[ct.column.field], rowData) }}
                        </ng-template>
                    </ng-template>
                </ng-container>

                <ng-template pTemplate="footer">
                    @if (!!aggregatedValues) {
                        <tr>
                            @for (column of tableSettings.columns; track column.field) {
                                @if (grid._isColumnVisible(column)) {
                                    <td [style.text-align]="aggregatedValues[column.field]?.textAlign || 'left'">
                                        {{ aggregatedValues[column.field]?.value }}
                                    </td>
                                }
                            }
                        </tr>
                    }
                </ng-template>
            </grid>

            <!--PDF view of the widget grid table. This element is visible in PDF view only.-->
            <!--It can be rendered hidden by demand, by setting renderPdfViewHidden to true.-->
            <table #pdfViewTable *ngIf="renderPdfViewHidden || output === 'PDF'"
                   [ngClass]="{'pdf-view-hidden' : renderPdfViewHidden}">

                <thead>
                <tr>
                    <th *ngFor="let column of getQueryColumnTemplates()" [style]="getColumnStyles(column.column)">
                        {{ column.column.header }}
                    </th>
                </tr>
                </thead>

                <tbody>
                <!--PDF view should NOT contain action column: it can break PDF exporting.-->
                <tr *ngFor="let row of gridPagedData?.items ?? []">
                    <td *ngFor="let column of getQueryColumnTemplates()" [style]="getColumnStyles(column.column)">

                        <ng-container *ngIf="!column.customTemplate; else customView">
                            {{ column.column.displayHandler(row[column.column.field], row) }}
                        </ng-container>

                        <ng-template #customView>
                            <div class="html-code-container" [innerHTML]="getCustomFormattedCellHtml(column, row)">
                            </div>
                        </ng-template>

                    </td>
                </tr>
                </tbody>

                <tfoot>
                    @if (!!aggregatedValues) {
                        <tr>
                            @for (column of columnTemplates; track column.column.field) {
                                <td [style.text-align]="aggregatedValues[column.column.field]?.textAlign || 'left'">
                                    {{ aggregatedValues[column.column.field]?.value }}
                                </td>
                            }
                        </tr>
                    }
                </tfoot>

            </table>
        </div>
    </div>
</ng-container>